/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SocialPostPlatform } from './SocialPostPlatform';
import {
    SocialPostPlatformFromJSON,
    SocialPostPlatformFromJSONTyped,
    SocialPostPlatformToJSON,
    SocialPostPlatformToJSONTyped,
} from './SocialPostPlatform';

/**
 * 
 * @export
 * @interface SocialPostConfig
 */
export interface SocialPostConfig {
    /**
     * Hashtag the post caption / title must contain (case-insensitive substring match). Include the leading `#` — e.g. `#FullThrottleChallenge`, `#RTTR26`.
     * @type {string}
     * @memberof SocialPostConfig
     */
    requiredHashtag: string;
    /**
     * Platforms the campaign accepts. Submissions on platforms not in this list return PLATFORM_UNVERIFIED.
     * @type {Array<SocialPostPlatform>}
     * @memberof SocialPostConfig
     */
    supportedPlatforms: Array<SocialPostPlatform>;
    /**
     * Optional per-user-per-segmentIndex submission cap. Omit to defer to the caller-side limit.
     * @type {number}
     * @memberof SocialPostConfig
     */
    maxPostsPerRound?: number;
}

/**
 * Check if a given object implements the SocialPostConfig interface.
 */
export function instanceOfSocialPostConfig(value: object): value is SocialPostConfig {
    if (!('requiredHashtag' in value) || value['requiredHashtag'] === undefined) return false;
    if (!('supportedPlatforms' in value) || value['supportedPlatforms'] === undefined) return false;
    return true;
}

export function SocialPostConfigFromJSON(json: any): SocialPostConfig {
    return SocialPostConfigFromJSONTyped(json, false);
}

export function SocialPostConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SocialPostConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'requiredHashtag': json['requiredHashtag'],
        'supportedPlatforms': ((json['supportedPlatforms'] as Array<any>).map(SocialPostPlatformFromJSON)),
        'maxPostsPerRound': json['maxPostsPerRound'] == null ? undefined : json['maxPostsPerRound'],
    };
}

export function SocialPostConfigToJSON(json: any): SocialPostConfig {
    return SocialPostConfigToJSONTyped(json, false);
}

export function SocialPostConfigToJSONTyped(value?: SocialPostConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'requiredHashtag': value['requiredHashtag'],
        'supportedPlatforms': ((value['supportedPlatforms'] as Array<any>).map(SocialPostPlatformToJSON)),
        'maxPostsPerRound': value['maxPostsPerRound'],
    };
}

